function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 44"
}, props), React.createElement("path", {
  d: "M1.46 37.353l11.632-15.727L.243 6.877 2.448.684l17.988 20.65L4.152 43.35 1.46 37.353z",
  fill: "#B0ADAD",
  fillOpacity: ".72"
})));